import React, { useEffect } from 'react';

import NumberKeys from './NumberKeys';
import IncrementKeys from './IncrementKeys';
import KeyboardButton from './KeyboardButton';
import Freebets from '../Freebets';

import {
    useKeyboard,
} from '~Betslip/store/keyboardContext';
import {
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';

import './styles.scss';

const AcceptKey = () => {
    const { closeKeyboard } = useKeyboard();

    return (
        <div className="fullslip__accept-key">
            <KeyboardButton
                keyText={'accept'}
                clickHandler={closeKeyboard}
                dataTestId={'betslip-keyboard;button-done'}
                gtmAttribute={'new-betslip;stake-area;confirm'}
            />
        </div>
    );
};

const Keyboard = () => {
    const { keyboardContainerRef } = useKeyboard();
    const isUserLoggedIn = useIsUserLoggedIn();

    useEffect(() => {
        if (keyboardContainerRef) {
            keyboardContainerRef.scrollIntoView({
                block: 'nearest',
            });
        }
    }, []);

    return (
        <div>
            {isUserLoggedIn
                ? <Freebets />
                : null
            }
            <div className="fullslip__keyboard">
                <NumberKeys />
                <IncrementKeys />
                <AcceptKey />
            </div>
        </div>
    );
};

export default Keyboard;
